<script lang="ts">
	export let width: string | number | null = 20;
	export let height: string | number | null = 20;
	export let viewBox: string = "0 0 20 20";
	export let fill: string | undefined = undefined;
	export let id: string | undefined = undefined;
	export let styleClass: string | undefined = undefined;
	export let useId: string | undefined = undefined;
	/**
	 * id of the svg symbol in the sprite
	 */
	export let template: string | undefined = undefined;
</script>

{#if typeof template === "string" && template.length > 0}
	<svg {id} {viewBox} {width} {height} class={styleClass} xmlns="http://www.w3.org/2000/svg">
		<use href="#{template}" xlink:href="#{template}" id={useId} {fill} />
	</svg>
{/if}
